function parseBoolean(input = '') {
    return String(input).toLowerCase() === 'true'
}

const config = {
    app: {
        url: process.env.REACT_APP_URL || '',
        adcreateUrl: process.env.REACT_APP_ADCREATE_URL || '',
        purgatoryDeviceId: 'HUBBLEAPP000',
        purgatoryUrl: process.env.REACT_APP_PURGATORY_URL || '',
        purgatorySocketUrl: process.env.REACT_APP_PURGATORY_SOCKET_URL || '',
        purgatorySocketPostfix: process.env.REACT_APP_PURGATORY_SOCKET_POSTFIX || '/service',
        appKey: {
            key: process.env.REACT_APP_APP_KEY,
            secret: process.env.REACT_APP_APP_SECRET,
        },
    },
    screenshots: {
        timeToReload: Number(process.env.REACT_APP_SCREENSHOT_TIME_TO_RELOAD || 60000),
        timeToRefreshOnDemand: Number(process.env.REACT_APP_SCREENSHOT_TIME_TO_REFRESH_ON_DEMAND || 10000),
    },
    sso: {
        resetPassword: process.env.REACT_APP_SSO_RESET_PASSWORD || '',
        url: process.env.REACT_APP_SSO_URL || '',
    },
    map: {
        timeToGoOffline: Number(process.env.REACT_APP_MAP_TIME_TO_GO_OFFLINE || 10000),
        timeToBeOffline: Number(process.env.REACT_APP_MAP_TIME_TO_BE_OFFLINE || 1800000),
        tilesServer: process.env.REACT_APP_MAP_TILES_SERVER || '',
    },
    reporter: {
        companyName: process.env.REACT_APP_REPORTER_COMPANY_NAME || '',
        productName: process.env.REACT_APP_REPORTER_PRODUCT_NAME || '',
        submitURL: process.env.REACT_APP_REPORTER_SUBMIT_URL || '',
        dsn: process.env.REACT_APP_REPORTER_DSN || '',
    },
    statistics: {
        resfreshTime: Number(process.env.REACT_APP_STATISTICS_REFRESH_TIME || 60000),
        storageAlertPercentage: 0.1,
    },
    authExceptions: JSON.parse(process.env.REACT_APP_AUTH_EXCEPTIONS || '[]'),
    headerExceptions: JSON.parse(process.env.REACT_APP_HEADER_EXCEPTIONS || '[]'),
    socket: {
        secret: process.env.REACT_APP_SOCKET_SECRET || '',
        uid: process.env.REACT_APP_SOCKET_UID || '',
    },
    auth0: {
        enabled: parseBoolean(process.env.REACT_APP_AUTH0_ENABLED),
        logoutRedirectUrl: process.env.REACT_APP_AUTH0_LOGOUT_REDIRECT || '',
        domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
        tenantDomain: process.env.REACT_APP_AUTH0_TENANT_DOMAIN || '',
        clientId: process.env.REACT_APP_AUTH0_CLIENTID || '',
        logo: process.env.REACT_APP_AUTH0_LOGO || 'https://files.volumenetwork.com/volume-logo-150x150.png',
    },
    uploads: {
        timeToFailUpload: process.env.REACT_APP_UPLOAD_TIME_TO_FAIL || 600000,
    },
    products: {
        currys: {
            api_url: process.env.REACT_APP_CURRYS_PRODUCTS_URL || '',
        },
    },
    powerbi: {
        clientId: process.env.REACT_APP_POWERBI_CLIENT_ID ?? '',
        authorityUrl: 'https://login.microsoftonline.com',
        tenantId: process.env.REACT_APP_POWERBI_TENANT_ID ?? '',
        apiUrl: 'https://api.powerbi.com',
        workspaceId: process.env.REACT_APP_POWERBI_WORKSPACE_ID ?? '',
        reportId: process.env.REACT_APP_POWERBI_REPORT_ID ?? '',
        scopeBase: ['https://analysis.windows.net/powerbi/api/Report.Read.All'],
    },
}

export default config
